import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import initModules from './init-modules';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState({ paths: ['auth'] })],
  modules: initModules(),
});
